import { SVG_ASSERT_URL } from '@/constants/app-constants';
import { Center, Image } from '@chakra-ui/react';

export const InvalidPage = () => {
  return (
    <Center flex="1">
      <Image src={`${SVG_ASSERT_URL}/assessment/404.svg`} />
    </Center>
  );
};
